var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ModalFullScreen",
    {
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c("ModalHeader", { attrs: { title: "Credit card is required" } }),
      _c(
        "div",
        { staticClass: "pb-5" },
        [
          _c("p", { staticClass: "flex pb-5" }, [
            _vm._v(
              " In order to reactivate subscription you need to select a payment option "
            ),
          ]),
          _c("ModalSectionsDivider"),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex" },
        [
          _c("UiButton", {
            staticClass: "mr-3",
            attrs: { buttonText: "Add credit card" },
            on: {
              click: function ($event) {
                return _vm.$emit("add")
              },
            },
          }),
          _c("UiButton", {
            attrs: { variant: "outline", buttonText: "Not now" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }